import { render, staticRenderFns } from "./UserReferralItem.vue?vue&type=template&id=6a8825ee&scoped=true&"
import script from "./UserReferralItem.vue?vue&type=script&lang=js&"
export * from "./UserReferralItem.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralItem.vue?vue&type=style&index=0&id=6a8825ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8825ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8825ee')) {
      api.createRecord('6a8825ee', component.options)
    } else {
      api.reload('6a8825ee', component.options)
    }
    module.hot.accept("./UserReferralItem.vue?vue&type=template&id=6a8825ee&scoped=true&", function () {
      api.rerender('6a8825ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/UserReferralItem.vue"
export default component.exports